import React, { useState, useEffect, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { useUnidades } from "../../hooks/test/useUnidades";
import Select from "react-select";
import { AuthContext } from "./../../context/authContext/authContext";

export const FiltroUnidades = ({
  unidades = [],
  setUnidades = () => {},
  unidadesActuales = [],
  setUnidadesActuales = () => {},
  flag = false,
  setFlag = () => {},
  clear = false,
  counter = 0,
  onChange,
}) => {
  /**
   * Formulario de datos
   */
  const [form, setForm] = useState({
    negocio: "",
    cedis: "",
    palabra: "",
    list_cedis: [],
    list_negocios: [],
  });
  const [allSelectCedis, allSetSelectCedis] = useState([]);
  const [selectCedis, setSelectCedis] = useState([]);
  const { getListaCedis, getNegocios } = useUnidades();
  const { user } = useContext(AuthContext);
  const [listaNegocios, setListaNegocios] = useState([]);

  /**
   * Esta funcion actualiza cada uno de los elementos del formulario recibiendo un parametro de tipo evento
   * @param {*} event
   */
  // const handleChange = (event) => {
  //   setForm({
  //     ...form,
  //     [event.target.name]: event.target.value,
  //   });
  // };

  const filterCedis = (values) => {
    let unidadesFiltradas = unidadesActuales;
    if (form.palabra) {
      unidadesFiltradas = unidadesFiltradas.filter((x) =>
        x.unidad_numero.includes(form.palabra)
      );
    }

    // unidadesFiltradas = filtrarUnidadesPorCedisGuardadas(unidadesFiltradas);

    if (values.length > 0 && values) {
      let aux = [];
      values.forEach((val) => {
        let n = unidadesFiltradas.filter(
          (x) => x.cedis_id === parseInt(val.value)
        );
        if (n) aux.push(...n);
      });
      unidadesFiltradas = aux;
    }
    setForm({ ...form, list_cedis: values });
  };

  // Extraemos los parametros de nuestro form
  const { palabra } = form;
  useEffect(() => {
    if (clear) {
      setForm({ ...form, negocio: "", cedis: "", palabra: "" });
    }
    return () => {
      setForm({ ...form, negocio: "", cedis: "", palabra: "" });
    };
  }, [clear]);

  useEffect(() => {
    setUnidadesActuales(unidades);
  }, []);
  useEffect(() => {
    if (flag) {
      setUnidadesActuales(unidades);
      setFlag(false);
    }
  }, [flag]);
  useEffect(() => {
    filterCedis(form.list_cedis);
  }, [counter]);

  useEffect(() => {
    loadInfo();
  }, []);

  const loadInfo = async () => {
    let resp = await getListaCedis();
    if (resp.ok) {
      const cedisFiltrados =
        (await user.roles_id) === 1 || (await user.roles_id) === 8
          ? resp.cedis.filter((x) => x.negocio_id === user.negocio_id)
          : resp.cedis;
      setSelectCedis(cedisFiltrados);
      allSetSelectCedis(cedisFiltrados);

      let res = await getNegocios();
      if (!res.ok) return;
      // Elimina duplicados en los IDs
      const negocioIds = [
        ...new Set(cedisFiltrados.map((item) => item.negocio_id)),
      ];

      // Filtra los negocios que coincidan con los IDs únicos
      const negocios = res.negocios.filter((r) =>
        negocioIds.includes(r.negocio_id)
      );

      setListaNegocios([...negocios]);
    }
  };

 const filterNegocios = async (values) => {

  // Si existen valores seleccionados
  if (values && values.length > 0) {
    const valoresValidos = values.map(item => item.value);

    // Filtra los CEDIS por negocio
    const cedisFiltrados = allSelectCedis.filter(item =>
      valoresValidos.includes(item.negocio_id)
    );

    // Solo actualiza la lista de CEDIS disponibles
    setSelectCedis(cedisFiltrados);

    // Actualiza solo negocios, NO toques list_cedis
    setForm({
      ...form,
      list_negocios: values,
    });

    // Si también se filtran unidades:
    let unidadesFiltradas = unidadesActuales.filter(item =>
      valoresValidos.includes(item.negocio_id)
    );

    setUnidades(unidadesFiltradas);
  } 
  
  else {
    // Reset total si no hay negocios seleccionados
    setForm({
      ...form,
      list_negocios: [],
      list_cedis: [], // aquí sí se limpia si quitan todos los negocios
    });

    // Recarga data base
    await loadInfo();
    setUnidades(unidadesActuales);
    setSelectCedis(allSelectCedis); // restaurar la lista completa
  }
};


  return (
    <>
      <div className="row mt-1 mb-4 fadeInDown animated delay-01s">
        {listaNegocios.length > 1 && (
          <div className="row">
            <div className="col-md-4 offset-md-4">
              <Select
                options={listaNegocios.map((x) => {
                  return { value: x.negocio_id, label: x.negocio_nombre };
                })}
                isMulti
                className="form-control selectCedis mb-4"
                classNamePrefix={"select"}
                value={form.list_negocios}
                onChange={filterNegocios}
                placeholder="Selecciona negocio"
              />
            </div>
          </div>
        )}
        <div className="col-4 col-md-12 col-lg-6 col-xl-4 ms-auto">
          <Select
            options={selectCedis.map((x) => ({
              value: x.cedis_id,
              label: x.nombre_cedis,
            }))}
            isMulti
            className="form-control selectCedis mb-4"
            classNamePrefix={"select"}
            value={form.list_cedis}
            onChange={(values) => {
              setForm({ ...form, list_cedis: values });

              // Convierte values → solo IDs
              const ids = values.map((v) => v.value);

              // Actualiza directamente todo el array
              onChange("arrayCedis", ids);

              filterCedis(values);
            }}
            placeholder="Selecciona cedis"
          />
        </div>
        <div className="col-4 col-md-12 col-lg-6 col-xl-4 me-auto inputWithIcon">
          <input
            className="form-control selectCedis"
            placeholder="BUSCAR UNIDAD"
            name="palabra"
            value={form.palabra}
            onChange={(e) => {
              const valor = e.target.value;
              setForm({ ...form, palabra: valor });
              onChange("palabra", valor);
            }}
          ></input>
          <button disabled={true}>
            <FontAwesomeIcon id="iconoBuscar" icon={faMagnifyingGlass} />
          </button>
        </div>
      </div>
    </>
  );
};
